// Czasy trwania notatki do wyboru (w minutach). 45 i 50 min — typowe zajęcia pozalekcyjne.
export const NOTE_DURATION_OPTIONS = [30, 45, 50, 60, 120, 180, 240]

export const formatNoteDuration = (minutes: number): string =>
  minutes < 60 || minutes % 60 !== 0 ? `${minutes} min` : `${minutes / 60} godz.`
